<template>
    <div v-if="series && series.length" class="mb-3">
        <div class="d-flex overflow-auto about-series-list">
            <a
                v-for="item in series"
                :key="item.id"
                :href="`/${item.slug}`"
                class="chip-item d-inline-flex align-items-center me-2"
            >
                <img
                    v-if="item.iconUrl"
                    :src="item.iconUrl"
                    :alt="item.name"
                    class="series-icon d-none d-md-block"
                />
                <span class="series-label">
          {{ item.name.replace('Cross Country', 'CC') }}
        </span>
            </a>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    series: {
        type: Array,
        required: true
    }
})
</script>

<style scoped>
.about-series-list {
    gap: 0.5rem;
    -webkit-overflow-scrolling: touch;
}
.chip-item {
    border: 1px solid #393939;
    border-radius: 5px;
    background-color: transparent;
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    color: #1ef1c6;
    text-decoration: none;
}
.series-icon {
    width: 60px;
    height: 35px;
    object-fit: contain;
    margin-right: 0.5rem;
}
.series-label {
    white-space: nowrap;
}
</style>
